var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "enhancements-selected" }, [
    _c(
      "div",
      {
        staticClass: "enhancements-selected-wrapper",
        class: [{ "multibooking-active": _vm.multiBookingIsActive }],
      },
      [
        _c("div", { staticClass: "enhancements-selected-header" }, [
          _vm._v(
            "Want to change your privileges? Simply remove to choose another."
          ),
        ]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.selectedEnhancements, function (enhancement) {
            return _c("enhancement-card", {
              key: enhancement.sitecoreId,
              attrs: { enhancement: enhancement },
              on: {
                "remove-enhancement": function ($event) {
                  return _vm.$emit("remove-enhancement", $event)
                },
                "edit-enhancement": function ($event) {
                  return _vm.$emit("edit-enhancement", $event)
                },
              },
            })
          }),
          1
        ),
        _vm._v(" "),
        _vm.multiBookingIsActive
          ? _c("div", { staticClass: "enhancements-multibooking form" }, [
              _c("label", [
                _c("input", {
                  attrs: {
                    id: "enhancements-multibooking-checkbox",
                    name: "enhancements_multibooking_checkbox",
                    type: "checkbox",
                  },
                  domProps: { checked: _vm.multiBookingCheckboxIsActive },
                  on: { input: _vm.onAction },
                }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.tc("booking.multiBookingCheckboxLabel")) +
                    "\n      "
                ),
              ]),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }